import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';

import { AuthService } from '@app/api/services/auth.service';

@Component({
    selector: 'app-shib-login',
    templateUrl: './shib-login.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./shib-login.component.scss']
})
export class ShibLoginComponent implements OnInit {

  constructor(private router: Router,
              private authService: AuthService) {}

  ngOnInit(): void {
    this.authService.shibboleth_login().subscribe(() => {
      this.router.navigateByUrl('home');
    });
  }
}
